(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/vikinglotto/components/play/assets/javascripts/views/package-rows-container.js') >= 0) return;  svs.modules.push('/modules/vikinglotto/components/play/assets/javascripts/views/package-rows-container.js');

'use strict';

svs.vikinglotto.components.play.views.PackageRowsContainer = Marionette.View.extend({
  className: 'numbergames-play-content grid-row padding-xs-h-1 padding-xs-bottom-2 padding-sm-h-1 padding-md-bottom-0 padding-md-h-2',
  regions: {
    sizePickerRegion: '#sizePickerRegion',
    packageRowsRegion: '#packageRowsRegion',
    packageHuxfluxRegion: '#packageHuxfluxRegion'
  },
  template(data) {
    return svs.vikinglotto.components.play.templates.package_rows_container(data);
  },
  onRender() {
    this.showChildView('sizePickerRegion', new svs.numbergames.game.views.SizePicker({
      model: this.model,
      invertButtons: true
    }));
    this.showChildView('packageRowsRegion', new svs.numbergames.game.views.PackageRows({
      className: 'package-rows package-rows-vikinglotto grid-row',
      model: this.model
    }));
    this.showChildView('packageHuxfluxRegion', new svs.numbergames.game.views.PackageHuxfluxButton({
      model: this.model
    }));
  }
});

 })(window);